import { IAction } from 'types';
import { select, put, call } from 'typed-redux-saga';
import { getFavorites, getLayerObject } from 'selectors';
import { toggleFavorite } from 'api/favorites';
import {
    Service,
    bindActionsTyped,
    latest,
    onStart
} from '../service-utils';
import { favoritesActions } from './favorites-reducer-actions';

import { IFavoritesItemPayload } from './favorites-reducer';

export class FavoritesService extends Service {
    static serviceName = 'FavoritesService';
    static generatedStopActionTypes: string[] = [];
    static generatedWatchers: Function[] = [];

    @latest
    static* addItem(action: IAction<IFavoritesItemPayload>) {
        let { layer_code, object_id } = action.payload;
        let favorites = yield* select(getFavorites);
        favorites = { ...favorites };
        let has_item = favorites[layer_code]?.includes(object_id) ?? false;

        if (!has_item) {
            favorites[layer_code] = favorites[layer_code]?.concat() ?? [];
            favorites[layer_code].push(object_id);
            yield* put(favoritesActions.setItems(favorites));
        }
    }

    @latest
    static* removeItem(action: IAction<IFavoritesItemPayload>) {
        let { layer_code, object_id } = action.payload;
        let favorites = yield* select(getFavorites);
        favorites = { ...favorites };
        let has_item = favorites[layer_code]?.includes(object_id) ?? false;

        if (has_item) {
            favorites[layer_code] = favorites[layer_code] || [];
            favorites[layer_code] = favorites[layer_code].filter(id => id !== object_id);

            if (favorites[layer_code].length === 0) {
                let {
                    [layer_code]: key_to_remove,
                    ...rest
                } = favorites;

                favorites = rest;
            }
            yield* put(favoritesActions.setItems(favorites));
        }
    }

    static* validateFavorites() {
        let favorites = yield* select(getFavorites);
        for (let [ layerCode, objectIds ] of Object.entries(favorites)) {
            for (let objectId of objectIds) {
                let object = yield* select(getLayerObject, layerCode, objectId);
                if (!object) {
                    console.log(`[FavValidation]: Не нашли объект из избранного ${layerCode}, ${objectId}`);
                    yield* call(FavoritesService.removeItem, {
                        type: '_',
                        payload: { layer_code: layerCode, object_id: objectId }
                    });
                }
            }
        }
    }
}


export const favoritesService: FavoritesService = new FavoritesService();
export const actions = bindActionsTyped(FavoritesService, favoritesService);
